import { useEffect, useId, useRef, useState, type MouseEvent, type ReactNode } from "react";
import { useTranslations } from "../../contexts/Translation";
import { Hamburger } from "../Icons";
import styles from "./MobileNav.module.css";

type ComponentProps = {
  children: ReactNode;
};

export const MobileNav = ({ children }: ComponentProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const t = useTranslations("menu");
  const panelId = useId();
  const rootRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const closePanel = (e: globalThis.MouseEvent) => {
      if (!(e.target instanceof Node) || !rootRef.current?.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.body.addEventListener("click", closePanel);
    return () => document.body.removeEventListener("click", closePanel);
  }, []);

  const closeOnLink = (e: MouseEvent<HTMLElement>) => {
    if (e.target instanceof Element && e.target.closest("a")) {
      setIsOpen(false);
    }
  };

  return (
    <div className={styles.root} ref={rootRef}>
      <button
        aria-controls={panelId}
        aria-expanded={isOpen}
        aria-label={t("openNavigation")}
        className={styles.toggle}
        onClick={() => setIsOpen((o) => !o)}
        type='button'
      >
        <Hamburger width='32px' height='32px' />
      </button>
      <nav id={panelId} className={styles.panel} hidden={!isOpen} onClick={closeOnLink}>
        {children}
      </nav>
    </div>
  );
};
